// ============================================================
// DM-LMS — Sessions Context
// Fetches GET /api/sessions exactly once per mount and shares the
// result with every consumer below the provider — same rationale as
// CoursesContext.
// ============================================================

import { createContext, useContext } from "react";
import type { ReactNode } from "react";
import { useFetch } from "../hooks/useApi.js";
import type { SessionWithCourse } from "@dm-lms/shared/types";

interface SessionsContextValue {
  sessions:  SessionWithCourse[];
  isLoading: boolean;
  error:     string | null;
}

const SessionsContext = createContext<SessionsContextValue | null>(null);

export function SessionsProvider({ children }: { children: ReactNode }) {
  const { data, isLoading, error } = useFetch<SessionWithCourse[]>("/api/sessions");

  return (
    <SessionsContext.Provider value={{ sessions: data ?? [], isLoading, error }}>
      {children}
    </SessionsContext.Provider>
  );
}

export function useSessions(): SessionsContextValue {
  const ctx = useContext(SessionsContext);
  if (!ctx) throw new Error("useSessions must be used within a SessionsProvider");
  return ctx;
}
